"use client";
import GroqLink from "@/components/ui/groq-link";
import { cn } from "@/lib/utils";
import { B2BAuthFormChat } from "@/shared/auth/b2b-auth-form/b2b-auth-form-chat";
import { reportClick } from "@/shared/lib/analytics";
import type { HTMLAttributes } from "react";

interface UserAuthFormProps extends HTMLAttributes<HTMLDivElement> {}

export default function UserAuthForm({
  className,
  ...props
}: UserAuthFormProps) {
  return (
    <div
      className={cn("grid gap-6 max-w-[420px] mx-auto", className)}
      {...props}
    >
      <div className="grid gap-3 px-4">
        <B2BAuthFormChat
          loginTitle="Login to continue chatting"
          hideHeaderText
          defaultReturnTo="/"
        />

        <div className="flex flex-col items-center">
          <p className="flex">
            Looking for an API?
            <GroqLink
              className="ml-1"
              href={{ pathname: process.env.NEXT_PUBLIC_GROQ_CLOUD }}
              isExternal
              onClick={() => reportClick("try_google_cloud_login")}
            >
              Try GroqCloud
            </GroqLink>
          </p>
        </div>
      </div>

      <p className="text-xs py-3 text-center">
        By continuing, I accept the
        <GroqLink
          className="mx-1"
          href="https://console.groq.com/docs/legal/services-agreement"
          isExternal
          variant={"secondary"}
        >
          Services Agreement
        </GroqLink>
        and acknowledge that I have read the .
        <GroqLink
          className="mx-1"
          href="https://groq.com/privacy-policy"
          isExternal
          variant={"secondary"}
        >
          Privacy Policy
        </GroqLink>
      </p>
    </div>
  );
}
